// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"96ddae54","38":"a9521ef0","53":"fd1d5e62","222":"be4e5b02","335":"1f50dd02","406":"e5a29e67","584":"fe9ab175","690":"f637719d","767":"da35a116","873":"e245c7c3","920":"3ac4a8f3"}[chunkId] + ".chunk.js";
};